import React from 'react';
import PropTypes from 'prop-types';
import {
    Popover,
    CardHeader,
    Divider,
    Box,
    Typography,
    List,
    CircularProgress,
    ListItem,
} from '@mui/material';

import NotificationItem from './NotificationItem';
import { useTranslation } from 'react-i18next';
import useInfiniteScroll from 'react-infinite-scroll-hook';


const NotificationsPopover = ({
    anchorEl,
    notifications,
    loading,
    hasNextPage,
    loadMore,
    notificationLoading,
    handleNotificationClick,
    error,
    ...rest
}) => {

    const { t } = useTranslation();
    const [sentryRef] = useInfiniteScroll({
        loading: notificationLoading,
        hasNextPage,
        onLoadMore: loadMore,
        disabled: !!error,
        rootMargin: '0px 0px 40px 0px',
    });

    return (
        <Popover
            {...rest}
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
            sx={{ maxHeight: '80%' }}
        >
            <Box
                sx={{
                    width: 350,
                    maxWidth: '100%'
                }}>
                <CardHeader title={t("Notifications")} />
                <Divider />
                {/* <NotificationList notifications={notifications} onClick={onClick} /> */}
                <List>
                    {notifications.map((notification, notificationIndex) => (
                        <NotificationItem
                            key={notification.id}
                            notificationIndex={notificationIndex}
                            notification={notification}
                            handleNotificationClick={handleNotificationClick}
                            notificationsLength={notifications?.length}
                        />
                    ))}

                    {(notificationLoading || hasNextPage) && <ListItem ref={sentryRef} sx={{ display: "flex", justifyContent: "center" }}>
                        <CircularProgress color="primary" size={40} />
                    </ListItem>}
                    {!notificationLoading && !notifications?.length && <ListItem sx={{ display: 'flex', justifyContent: "center" }}>
                        <Typography color="primary" >{t("No notifications yet")}</Typography>
                    </ListItem>}
                    {!notificationLoading && !!notifications?.length && !hasNextPage && <ListItem sx={{ display: 'flex', justifyContent: "center" }}>
                        <Typography color="primary" >{t("No more notifications")}</Typography>
                    </ListItem>}
                </List>
                {
                    error &&
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Typography variant="caption" color="error">{error}</Typography>
                    </Box>
                }
                <Divider />
            </Box>
        </Popover>
    );
};

NotificationsPopover.propTypes = {
    anchorEl: PropTypes.any,
    className: PropTypes.string,
    notifications: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
};

export default NotificationsPopover;
